/** Values shared between the API, the console and the widget. */
export const FACT_SOURCES = ['training_chat', 'manual', 'gap_resolution'];
export const FACT_STATUSES = ['active', 'archived'];
export const GAP_STATUSES = ['open', 'resolved', 'dismissed'];
export const VISITOR_MESSAGE_STATUSES = ['new', 'handled'];
export const FALLBACK_MODES = ['message', 'contact', 'both'];
export const CHANNELS = ['widget', 'training'];
export const MESSAGE_ROLES = ['user', 'assistant'];
export const USER_ROLES = ['owner', 'staff'];
export const TENANT_STATUSES = ['active', 'disabled'];
/** Lifecycle of a tenant's connection to their own backend. */
export const ACCOUNT_CONNECTION_STATUSES = ['disabled', 'testing', 'live'];
/** Outcome of one account lookup, as recorded in the audit trail. */
export const ACCOUNT_LOOKUP_STATUSES = ['ok', 'denied', 'error', 'timeout'];
/** Field limits enforced at the API boundary and mirrored in client-side forms. */
export const LIMITS = {
    factContent: 2000,
    personaNotes: 2000,
    greeting: 500,
    botName: 60,
    contactInfo: 500,
    tenantName: 120,
    tenantSlug: 60,
    email: 254,
    password: { min: 10, max: 200 },
    accountBaseUrl: 500,
    accountActionName: 40,
    accountActionDescription: 500,
    accountSecret: { min: 32, max: 200 },
    /** The `sub` claim we bind a conversation to. */
    endUserRef: 128,
    endUserLabel: 200,
    /** Generous: a tenant's JWT may carry claims we ignore. */
    accountToken: 4096,
};
/** Default appearance applied to a freshly created tenant. */
export const DEFAULT_SETTINGS = {
    botName: 'Assistant',
    brandColor: '#2563eb',
    greeting: 'Hi! Ask me anything — I can help with questions about us.',
    personaNotes: 'Friendly, concise and professional.',
    fallbackMode: 'both',
};
/** Names of the tools the model may call. Kept here so tests can assert on them. */
export const TOOL_NAMES = {
    reportGap: 'report_gap',
    takeMessage: 'take_message',
    saveFact: 'save_fact',
    updateFact: 'update_fact',
    archiveFact: 'archive_fact',
};
/**
 * Every tenant-declared account tool is namespaced with this prefix, so a
 * manifest can never shadow one of the built-in tools above.
 */
export const ACCOUNT_TOOL_PREFIX = 'account_';
/**
 * Keys the model is not allowed to set on an account lookup: the subject comes
 * from the verified identity token, never from the model. Anything matching is
 * stripped before the call and flagged on the audit row.
 */
export const RESERVED_ACCOUNT_PARAM_KEYS = [
    'subject',
    'sub',
    'user_id',
    'userid',
    'userId',
    'customer_id',
    'customerId',
    'account_id',
    'accountId',
];
//# sourceMappingURL=constants.js.map